<div fxLayout="column">
  <!-- IE requires all fxLayout="column" elements to have the child contents wrapped in a plain div tag -->
  <div *ngIf="isBrowserIE; else faqFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
    <ng-container *ngTemplateOutlet="faqFlexColumnTemplate"></ng-container>
  </div>
</div>

<ng-template #faqFlexColumnTemplate>
  <div fxFlex.lt-sm="10px" fxFlex.gt-sm="25px">&nbsp;</div>         <!-- 11/01/2021 RA - Increased from 10px to 60px to move info box down -->
  <div fxFlex="100%" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap.lt-md="10px">
    <div *ngIf="isBrowserIE && media.isActive('lt-md'); else faqMainFlexColumnTemplate">
      <ng-container *ngTemplateOutlet="faqMainFlexColumnTemplate"></ng-container>
    </div>
  </div>
  <div fxFlex.lt-md="10px" fxFlex.gt-sm="25px">&nbsp;</div>
</ng-template>

<ng-template #faqMainFlexColumnTemplate>
  <div fxFlex="5%" fxHide.lt-md></div>
  <div fxFlex="90%" ngStyle.lt-md="padding-left: 8px; padding-right: 8px" *ngIf="showSpinner">
    <div class="display-text normal-paragraph-spacing" style="text-align: center">
      <mat-spinner color="accent" diameter="64"></mat-spinner>
    </div>
  </div>
  <div fxFlex="90%" ngStyle.lt-md="padding-left: 8px; padding-right: 8px" *ngIf="!showSpinner">
    <div class="display-text normal-paragraph-spacing">
      <mat-card>
        <mat-card-content>
          <div fxLayout="column" *ngIf="!faqsFound">
            <div *ngIf="isBrowserIE; else faqNoRecordsFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
              <ng-container *ngTemplateOutlet="faqNoRecordsFlexColumnTemplate"></ng-container>
            </div>
          </div>
          <div fxLayout="column" *ngIf="faqsFound">
            <div *ngIf="isBrowserIE; else faqListFlexColumnTemplate">
              <ng-container *ngTemplateOutlet="faqListFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }"></ng-container>
            </div>
          </div>
          <div fxLayout="column">
            <div *ngIf="isBrowserIE; else faqScrollToTopFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
              <ng-container *ngTemplateOutlet="faqScrollToTopFlexColumnTemplate"></ng-container>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  <div fxFlex="5%" fxHide.lt-md></div>
</ng-template>

<ng-template #faqNoRecordsFlexColumnTemplate>
  <div fxLayout="column">
    <div class="display-text primary-dark-color-important">
      <b><span i18n="@@faq.list.title">faq.list.title</span></b>
    </div>
    <div class="display-text">
      <i><span i18n="@@faq.list.no-records-text">faq.list.no-records-text</span></i>
    </div>
  </div>
</ng-template>

<ng-template #faqListFlexColumnTemplate>
  <div fxLayout="column">
    <div class="display-text primary-dark-color-important">
      <b><span i18n="@@faq.list.title">faq.list.title</span></b>
    </div>
    <div class="border-bottom-blue" style="margin-top: 16px; margin-bottom: 16px;"></div>
    <div fxLayout="column" class="display-text" *ngFor="let faq of this.faqTextList">
      <div class="display-text primary-color">
        <b>{{ faq.faqQuestion }}</b>
      </div>
      <div markdown [data]="faq.faqAnswer" class="display-text normal-paragraph-spacing"></div>
    </div>
  </div>
</ng-template>

<ng-template #faqScrollToTopFlexColumnTemplate>
  <div fxLayout="column" *ngIf="faqsFound">
    <div fxLayoutAlign="center center" style="margin-top: 24px;">
      <button mat-stroked-button color="primary" (click)="scrollToTop()" i18n="@@faq.list.go-to-top">faq.list.go-to-top</button>
    </div>
  </div>
</ng-template>
